<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sgc-toc-title">Contents</h1>
<div class="sgc-toc-level-1">
<a href="#/Text/06_part01"><i>Part I</i></a>
<div class="sgc-toc-level-2">
<a href="#/Text/07_prologue">A Prologue</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/08_ch01">A Tree to Be Desired</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/09_ch02">While We Waited for You to Be Born</a>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/10_ch03" title="Link target outside of Sample">The Carnival of the Stoned Children</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/11_ch04" title="Link target outside of Sample">Mississippi</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/12_ch05" title="Link target outside of Sample">Miss Crystal Confronts the Past</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/13_ch06" title="Link target outside of Sample">A Sordid Tale, or, Traceleen Continues Talking</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/14_ch07" title="Link target outside of Sample">Phyladda, or, The Mind/Body Problem</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/15_ch08" title="Link target outside of Sample">Battle</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/16_part02" title="Link target outside of Sample"><i>Part I</i></span>
<div class="sgc-toc-level-2">
<span href="#/Text/17_ch09" title="Link target outside of Sample">The Triumph of Reason</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/18_ch10" title="Link target outside of Sample">Have a *Wonderful* Nice Walk</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/19_ch11" title="Link target outside of Sample">Witness to the Crucifixion</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/20_ch12" title="Link target outside of Sample">Ocean Springs</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/21_part03" title="Link target outside of Sample"><i>Part III   Abstract and Brief Chronicles of the Times</i></span>
<div class="sgc-toc-level-2">
<span href="#/Text/22_ch13" title="Link target outside of Sample">Excitement at Drake Field</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/23_ch14" title="Link target outside of Sample">A Lady with Pearls</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/24_ch15" title="Link target outside of Sample">Excitement in Audubon Park</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/25_ch16" title="Link target outside of Sample">Free Pull</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/26_ch17" title="Link target outside of Sample">Down at the Dollhouse</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/27_ch18" title="Link target outside of Sample">The Southwest Experimental Fast Oxide Reactor</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/MoreFrom" title="Link target outside of Sample">Also by Ellen Gilchrist</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/ConnectWithDB" title="Link target outside of Sample">Connect with Diversion Books</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?1830580a